export const TRIAL_MODAL = 'trial_modal';
export const ADD_PAYMENT_MODAL = 'add_payment_modal';
export const UPDATE_PAYMENT_MODAL = 'update_payment_modal';

export const GOOGLE_PAY = 'google_pay';
export const APPLE_PAY = 'apple_pay';
